import { render, staticRenderFns } from "./selectPoint.vue?vue&type=template&id=6ff2bb1c&scoped=true&"
import script from "./selectPoint.vue?vue&type=script&lang=js&"
export * from "./selectPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2bb1c",
  null
  
)

export default component.exports